import { createContext, useContext, useMemo } from 'react';
import { useRoutes } from './use-routes.js';

const Context = createContext();

export const useAdminContext = () => useContext(Context);

export function Provider({ children }) {
  const routes = useRoutes();
  const hasAccess = Boolean(routes.length);

  const state = useMemo(() => ({ hasAccess, routes }), [hasAccess, routes]);

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
